import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {$agentFactory} from "../../../agents/$agent.factory";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {VehiclesAlerts} from "../../services/vehicles-alerts.service";
import {VehiclesDialogService} from "../../services/vehicles-dialog.service";
import {VehiclesRequests} from "../../services/vehicles-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class VehiclesViewCtrl implements IController {

  private vehiclesRef: any;
  private agentsRef: any;
  private vehicles: any;
  private agents: any;
  private selectedVehicle: any;
  private loading: boolean;
  // private vehicleTypesRef: any;
  private selectedType: VehicleType;
  private defaultVehicleSelectedId: any;
  public vehicleTypesList: VehicleType[];

  /* @ngInject */
  constructor(private $vehicles, private bringozLoaderService: BringozLoaderService, private $log, private $agent: $agentFactory,
              private $agents: $agentsFactory, private vehiclesAlerts: VehiclesAlerts, private confirmDialogService: ConfirmDialogService, private vehiclesDialogService: VehiclesDialogService,
              private vehiclesRequests: VehiclesRequests, private agentDialogService: AgentDialogService) {
    this.vehicleTypesList = Object.values(VehicleType);
  }

  $onInit() {
    this.vehiclesRef = this.$vehicles();
    this.agentsRef = this.$agents();
    this.vehicles = [];
    this.agents = [];
    this.selectedVehicle = undefined;
    this.loading = false;
    this.selectedType = null;
    this._initVehicles(this.selectedType);
  };

  // ******************************
  //        Public methods
  // ******************************

  onChangeToDefaultVehicle(vehicle, $event) {
    this.confirmDialogService.confirm('Change Default Vehicle', 'Do you wish to select this vehicle as default?', $event)
        .then(() => {
          vehicle.isDefault = !vehicle.isDefault;
          this.defaultVehicleSelectedId = vehicle.isDefault ? vehicle.id : this._getDefaultVehicleId();
          this._updateVehicle(vehicle);
        })
  }

  onSelectedClassChange() {
    this.selectedVehicle = undefined;
    this.agents = [];
    this._initVehicles(this.selectedType);
  }

  onVehicleSelect(vehicle) {
    this.selectedVehicle = vehicle;

    if (vehicle) {
      this._setAgentsByVehicleId(vehicle.id);
    } else {
      this.agents = [];
    }
  }

  onCreateVehicle(event) {
    this.vehiclesDialogService.createNewVehicleType(event)
        .then((vehicleToCreate) => {
          this._createVehicle(vehicleToCreate);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
  }

  onEditVehicleInfo(vehicle, $event) {
    this.vehiclesDialogService.createNewVehicleType($event, vehicle)
        .then((vehicleToUpdate) => {
          this._updateVehicle(vehicleToUpdate);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        });
  }

  onEditVehicleCapacity(vehicle, $event) {
    this.vehiclesDialogService.editVehicleCapacity(vehicle, $event)
        .then((vehicleToUpdate) => {
          this._updateVehicle(vehicleToUpdate);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        });
  }

  onDeleteVehicle(vehicle) {
    this.confirmDialogService.confirm('Delete Vehicle', 'Are you sure you want to delete vehicle?')
        .then(() => {
          this._removeVehicle(vehicle);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })

  }

  onAddDriverToVehicle(vehicle, event) {
    const agentIds = _.map(this.agents, 'id');
    this.agentDialogService.addAgents(event, agentIds)
        .then((payload) => {
          this._addAgentToVehicle(vehicle, payload.ids, payload.excludeIds);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed', error);
        })
  }

  _addAgentToVehicle(vehicle, ids, excludeIds) {
    if (!vehicle || !ids) {
      return;
    }
    this.loading = true;
    this.bringozLoaderService.on();
    this.vehiclesRequests.updateAgents([vehicle.id], ids, excludeIds)
        .then((agentsAdded) => {
          this.agents = this.agents.concat(agentsAdded);
          this.vehiclesAlerts.addDriverSuccess();
        })
        .catch((error) => {
          this.vehiclesAlerts.addDriverError();
          this.$log.error('Failed to add driver to vehicle', error);
        })
        .finally(() => {
          this.loading = false;
          this.bringozLoaderService.off();
        });
  }


  // ******************************
  //        Private methods
  // ******************************

  _initVehicles(type) {
    this.bringozLoaderService.on();
    this.vehiclesRef.$getAll({type: type})
        .then((vehicleIds) => {
          return this.vehiclesRef.$asyncValues(vehicleIds);
        })
        .then((vehicles) => {
          this.vehicles = vehicles;
          this.defaultVehicleSelectedId = this._getDefaultVehicleId();
        })
        .catch((error) => {
          this.$log.error('Failed to get vehicles', error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })
  }

  _getDefaultVehicleId() {
    const defaultVehicles = _.filter(this.vehicles, (v) => {
      return v.isDefault == true;
    })
    return defaultVehicles[0].id;
  }

  _createVehicle(vehicleToCreate) {
    this.bringozLoaderService.on();
    this.vehiclesRequests.create(vehicleToCreate)
        .then((createdVehicle) => {
          this.vehicles.unshift(createdVehicle);
          this.vehiclesAlerts.createSuccess();
        })
        .catch((error) => {
          if (error) {
            this.vehiclesAlerts.createError();
            this.$log.error('Failed to create vehicle', error);
          }
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })
  }

  _updateVehicle(vehicleToUpdate) {
    this.bringozLoaderService.on();
    this.vehiclesRequests.update(vehicleToUpdate.id, vehicleToUpdate)
        .then((updatedVehicle) => {
          if (this.selectedVehicle) {
            this.selectedVehicle = updatedVehicle;
          }
          const vehiclesRef = this.vehicles;

          const vehicleIndex = _.findIndex(this.vehicles, (v: any) => {
            return v.id === updatedVehicle.id;
          });
          vehiclesRef.splice(vehicleIndex, 1, updatedVehicle);
          this.vehicles = vehiclesRef;
          this.vehiclesAlerts.updateSuccess();
        })
        .catch((error) => {
          if (error) {
            this.vehiclesAlerts.updateError();
            this.$log.error('Failed to update vehicle', error);
          }
        })
        .finally(() => {
          this.bringozLoaderService.off()
        })
  }

  _removeVehicle(vehicle) {
    this.bringozLoaderService.on();
    this.vehiclesRequests.remove(vehicle.id)
        .then(() => {
          this.selectedVehicle = undefined;
          this.vehicles = _.filter(this.vehicles, (v) => {
            return v.id !== vehicle.id;
          });
          this.vehiclesAlerts.deleteOneSuccess(vehicle);
        })
        .catch((error) => {
          if (error) {
            this.vehiclesAlerts.deleteOneError();
            this.$log.error('Failed to delete vehicle', error);
          }
        })
        .finally(() => {
          this.bringozLoaderService.off();
        })
  }

  _setAgentsByVehicleId(vehicleId) {
    this.agents = [];

    this.loading = true;
    this.agentsRef.$getAll({vehicleId: vehicleId, isActive: true})
        .then((ids) => {
          return this.agentsRef.$asyncValues(ids);
        })
        .then((agents) => {
          this.agents = agents;
        })
        .catch((error) => {
          this.$log.error('Failed to get agents @vehiclePanel@$onChanges', error);
        })
        .finally(() => {
          this.loading = false;
        })
  }

}

angular
    .module('bringoz.admin.vehicles')
    .component('vehiclesView', {
      bindings: {},
      template: require('./vehicles-view.html').default,
      controller: VehiclesViewCtrl
    });
